export const GET_LISTS = "GET_LISTS";
export const GET_LIST = "GET_LIST";
export const CREATE_LIST = "CREATE_LIST";
export const UPDATE_LIST = "UPDATE_LIST";
export const DELETE_LIST = "DELETE_LIST";
